export const UPSERT_VELOCITY_LIMIT_ATTRIBUTES_CONSTANT = {
  srcCountry: {
    type: 'select',
    key: 'src_country',
    label: 'Source Country',
  },
  destCountry: {
    type: 'select',
    key: 'dest_country',
    label: 'Destination Country',
  },
  sourceCurrency: {
    type: 'text',
    key: 'source_currency',
    label: 'Source Currency',
  },
  destinationCurrency: {
    type: 'text',
    key: 'destination_currency',
    label: 'Destination Currency',
  },
} as const;
